import { gql } from 'graphql-tag'

const defaultActivityDescriptionFragment = gql`
  fragment DefaultActivityDescriptionFragment on ActivityDescription {
    id
    name
    description
    station {
      id
      name
    }
  }
`

export const fetchStationActivityDescriptions = gql`
  query FetchActivityDescriptions($stationId: ID!) {
    stationActivityDescriptions(stationId: $stationId) {
      ...DefaultActivityDescriptionFragment
    }
  }
  ${defaultActivityDescriptionFragment}
`

export const createActivityDescriptionMutation = gql`
  mutation CreateActivityDescription($name: String!, $description: String!, $stationId: ID!) {
    createActivityDescription(name: $name, description: $description, stationId: $stationId) {
      ...DefaultActivityDescriptionFragment
    }
  }
  ${defaultActivityDescriptionFragment}
`

export const updateActivityDescriptionMutation = gql`
  mutation UpdateActivityDescription($activityDescriptionId: ID!, $description: String!) {
    updateActivityDescription(id: $activityDescriptionId, description: $description) {
      ...DefaultActivityDescriptionFragment
    }
  }
  ${defaultActivityDescriptionFragment}
`
